module.exports = __webpack_public_path__ + "static/media/Pipeline_IPOIntelligence_base.119198bb.png";